"use strict";
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPOVER_TRANSITION_TIMING = exports.FLOATING_ALERT_TIMING = exports.HOVERLAY_TRANSITION_TIMING = exports.MODAL_BACKGROUND_TRANSITION_TIMING = exports.PANEL_TRANSITION_TIMING = exports.SLIDEIN_MODAL_TRANSITION_TIMING = exports.DEFAULT_MODAL_TRANSITION_TIMING = exports.EDITABLE_CONTROLS_TRANSITION_TIMING = exports.MICRO_TRANSITION_TIMING = exports.NAV_LIST_TRANSITION_ANIMATION_TIMING = exports.TABS_ACTIVATE_TRANSITION_TIMING = exports.CARD_TRANSITION_ANIMATION_TIMING = exports.PANEL_NAVIGATOR_TRANSITION_TIMING = void 0;
var PANEL_NAVIGATOR_TRANSITION_TIMING = '400ms';
exports.PANEL_NAVIGATOR_TRANSITION_TIMING = PANEL_NAVIGATOR_TRANSITION_TIMING;
var CARD_TRANSITION_ANIMATION_TIMING = '200ms';
exports.CARD_TRANSITION_ANIMATION_TIMING = CARD_TRANSITION_ANIMATION_TIMING;
var TABS_ACTIVATE_TRANSITION_TIMING = '200ms';
exports.TABS_ACTIVATE_TRANSITION_TIMING = TABS_ACTIVATE_TRANSITION_TIMING;
var NAV_LIST_TRANSITION_ANIMATION_TIMING = '200ms';
exports.NAV_LIST_TRANSITION_ANIMATION_TIMING = NAV_LIST_TRANSITION_ANIMATION_TIMING;
var MICRO_TRANSITION_TIMING = '150ms';
exports.MICRO_TRANSITION_TIMING = MICRO_TRANSITION_TIMING;
var EDITABLE_CONTROLS_TRANSITION_TIMING = '250ms';
exports.EDITABLE_CONTROLS_TRANSITION_TIMING = EDITABLE_CONTROLS_TRANSITION_TIMING;
var DEFAULT_MODAL_TRANSITION_TIMING = '350ms';
exports.DEFAULT_MODAL_TRANSITION_TIMING = DEFAULT_MODAL_TRANSITION_TIMING;
var SLIDEIN_MODAL_TRANSITION_TIMING = '300ms';
exports.SLIDEIN_MODAL_TRANSITION_TIMING = SLIDEIN_MODAL_TRANSITION_TIMING;
var PANEL_TRANSITION_TIMING = '150ms';
exports.PANEL_TRANSITION_TIMING = PANEL_TRANSITION_TIMING;
var MODAL_BACKGROUND_TRANSITION_TIMING = '100ms';
exports.MODAL_BACKGROUND_TRANSITION_TIMING = MODAL_BACKGROUND_TRANSITION_TIMING;
var HOVERLAY_TRANSITION_TIMING = '200ms';
exports.HOVERLAY_TRANSITION_TIMING = HOVERLAY_TRANSITION_TIMING;
var FLOATING_ALERT_TIMING = '300ms';
exports.FLOATING_ALERT_TIMING = FLOATING_ALERT_TIMING;
var POPOVER_TRANSITION_TIMING = '200ms';
exports.POPOVER_TRANSITION_TIMING = POPOVER_TRANSITION_TIMING;